import Button from "components/atoms/Button";
import Checkbox from "components/atoms/Checkbox";
import { CheckboxButton } from "components/atoms/CheckboxButton";
import Heading from "components/atoms/Heading";
import Icon from "components/atoms/Icon";
import { Box } from "components/molecules/Box";
import Carousel from "components/molecules/Carousel";
import CarouselItem from "components/molecules/Carousel/CarouselItem";
import { RangeNumber } from "components/molecules/Range";
import { maxQuery, SizeMax } from "constants/media";
import { HOME } from "constants/swiper";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { requestFetchProductsByType } from "redux/actions/products/byType";
import styled, { css } from "styled-components/macro";
import { SwiperSlide } from "swiper/react";
import { getRoomValue } from "utils/common";
import feature3Active from "../../../images/icons/dieu-kien-tien-nghi-active.svg";
import feature3 from "../../../images/icons/dieu-kien-tien-nghi.svg";
import feature4Active from "../../../images/icons/do-ben-cao-active.svg";
import feature4 from "../../../images/icons/do-ben-cao.svg";
import feature5Active from "../../../images/icons/lam-lanh-nhanh-active.svg";
import feature5 from "../../../images/icons/lam-lanh-nhanh.svg";
import feature7Active from "../../../images/icons/loc-khong-khi-active.svg";
import feature7 from "../../../images/icons/loc-khong-khi.svg";
import invterterActive from "../../../images/icons/logo-invterter-active.svg";
import invterter from "../../../images/icons/logo-invterter.svg";
import feature1Active from "../../../images/icons/luong-gio-ba-chieu-active.svg";
import feature1 from "../../../images/icons/luong-gio-ba-chieu.svg";
import feature2Active from "../../../images/icons/luong-gio-coanda-active.svg";
import feature2 from "../../../images/icons/luong-gio-coanda.svg";
import snowflakeBlue from "../../../images/icons/snowflake-blue.svg";
import snowflakeGray from "../../../images/icons/snowflake-gray.svg";
import snowpartBlue from "../../../images/icons/snowpart-blue.svg";
import snowpartGray from "../../../images/icons/snowpart-gray.svg";
import feature6Active from "../../../images/icons/tiet-kiem-nang-luong-active.svg";
import feature6 from "../../../images/icons/tiet-kiem-nang-luong.svg";
import { GridCol, GridRow } from "../Grid";
import "./index.scss";
interface FilterProductsProps {
  onCloseAnimation?: () => void;
}

type ValueTypes = "area" | "electric" | "condition" | "room" | "feature";

type ComonTypes = {
  value: string;
  label: string;
  name?: string;
};

type PriceTypes = {
  checked: boolean;
  name: string;
  title: string;
  value: string;
};

const roomSplit = [
  { value: "1", label: "Phòng khách" },
  { value: "2", label: "Phòng ngủ" },
  { value: "3", label: "Phòng trẻ em" },
  { value: "4", label: "Phòng học" },
];

const featureTypeList = [
  {
    value: "2",
    label: "Luồng gió 3 chiều",
    name: "LUONG_GIO_3_CHIEU",
    iconNoneActive: feature1,
    iconActive: feature1Active,
  },
  {
    value: "6",
    label: "Luồng Gió Coanda",
    name: "LUONG_GIO_COANDA",
    iconNoneActive: feature2,
    iconActive: feature2Active,
  },
  {
    value: "9",
    label: "Điều khiển tiện nghi",
    name: "DIEU_KHIEN_TIEN_NGHI",
    iconNoneActive: feature3,
    iconActive: feature3Active,
  },
  {
    value: "8",
    label: "Độ bền cao",
    name: "DO_BEN_CAO",
    iconNoneActive: feature4,
    iconActive: feature4Active,
  },
  {
    value: "3",
    label: "Làm lạnh nhanh",
    name: "LAM_LANH_NHANH",
    iconNoneActive: feature5,
    iconActive: feature5Active,
  },
  {
    value: "4",
    label: "Tiết kiệm năng lượng",
    name: "TIET_KIEM_NANG_LUONG",
    iconNoneActive: feature6,
    iconActive: feature6Active,
  },
  {
    value: "5",
    label: "Lọc không khí",
    name: "TINH_LOC_KHONG_KHI",
    iconNoneActive: feature7,
    iconActive: feature7Active,
  },
];

const FilterProducts: React.FC<FilterProductsProps> = (
  props: FilterProductsProps,
) => {
  const [price, setPrice] = useState<Array<number>>([8000000, 12000000]);
  const [areaTypes, setAreaTypes] = useState<Array<ComonTypes>>([]);
  const [electricTypes, setElectricTypes] = useState<Array<ComonTypes>>([]);
  const [airConditionType, setAirConditionType] = useState<Array<ComonTypes>>(
    [],
  );
  const [roomTypes, setRoomTypes] = useState<Array<ComonTypes>>([]);
  const [featureTypes, setFetureTypes] = useState<Array<ComonTypes>>([]);
  const [priceTypes, setPriceTypes] = useState<Array<PriceTypes>>([]);

  const dispatch = useDispatch();
  const history = useHistory();

  const { homeFilter } = useSelector(state => state.products.byType.data);

  const onCheckValuesFilter = useCallback(
    (value: string, label: string, type: ValueTypes, name?: string) => {
      switch (type) {
        case "area":
          const findValueAreaExist = areaTypes.find(
            item => item.value === value,
          );

          if (findValueAreaExist) {
            setAreaTypes(areaTypes.filter(item => item.value !== value));
          } else {
            setAreaTypes([...areaTypes, { value: value, label: label }]);
          }
          break;
        case "electric":
          const findValueElectricExist = electricTypes.find(
            item => item.value === value,
          );

          if (findValueElectricExist) {
            setElectricTypes(
              electricTypes.filter(item => item.value !== value),
            );
          } else {
            setElectricTypes([
              ...electricTypes,
              { value: value, label: label },
            ]);
          }
          break;
        case "condition":
          const findValueConditionExist = airConditionType.find(
            item => item.value === value,
          );

          if (findValueConditionExist) {
            setAirConditionType(
              airConditionType.filter(item => item.value !== value),
            );
          } else {
            setAirConditionType([
              ...airConditionType,
              { value: value, label: label },
            ]);
          }
          break;
        case "room":
          const findValueRoomExist = roomTypes.find(
            item => item.value === value,
          );

          if (findValueRoomExist) {
            setRoomTypes(roomTypes.filter(item => item.value !== value));
          } else {
            setRoomTypes([...roomTypes, { value: value, label: label }]);
          }
          break;
        case "feature":
          const findValueFetureExist = featureTypes.find(
            item => item.value === value,
          );

          if (findValueFetureExist) {
            setFetureTypes(featureTypes.filter(item => item.value !== value));
          } else {
            setFetureTypes([
              ...featureTypes,
              { value: value, label: label, name: name },
            ]);
          }
          break;
        default:
          break;
      }
    },
    [airConditionType, areaTypes, electricTypes, featureTypes, roomTypes],
  );

  const CONST_PRICE = {
    LESS_THAN_8000: "< 8.000.000đ",
    BETWEEN_8000_12000: "8.000.000đ - 12.000.000đ",
    BETWEEN_8000_15000: "8.000.000đ - > 15.000.000đ",
    BETWEEN_12000_15000: "12.000.000đ - 15.000.000đ",
    FROM_15000: "> 15.000.000đ",
    LESS_THAN_8000_TITLE: "Dưới 8.000.000đ",
    FROM_15000_TITLE: "Trên 15.000.000đ",
    PRICE_1: "PRICE_1",
    PRICE_2: "PRICE_2",
    PRICE_3: "PRICE_3",
    PRICE_4: "PRICE_4",
  };

  const priceChange = useMemo(() => {
    if (price[1] === 8000000) {
      return CONST_PRICE.LESS_THAN_8000;
    } else if (price[1] === 12000000) {
      return CONST_PRICE.BETWEEN_8000_12000;
    } else if (price[0] === 12000000 && price[1] === 16000000) {
      return CONST_PRICE.BETWEEN_12000_15000;
    } else if (price[0] === 8000000 && price[1] === 16000000) {
      return CONST_PRICE.BETWEEN_8000_15000;
    } else {
      return CONST_PRICE.FROM_15000;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [price]);

  useEffect(() => {
    const findValueAreaExist = priceTypes.find(
      item => item.title === priceChange,
    );

    if (findValueAreaExist) {
      setPriceTypes(priceTypes.filter(item => item.title === priceChange));
    } else {
      if (priceChange === CONST_PRICE.LESS_THAN_8000) {
        setPriceTypes([
          {
            value: "1",
            title: CONST_PRICE.LESS_THAN_8000_TITLE,
            name: CONST_PRICE.PRICE_1,
            checked: false,
          },
        ]);
      } else if (priceChange === CONST_PRICE.BETWEEN_8000_12000) {
        setPriceTypes([
          {
            value: "2",
            title: CONST_PRICE.BETWEEN_8000_12000,
            name: CONST_PRICE.PRICE_2,
            checked: false,
          },
        ]);
      } else if (priceChange === CONST_PRICE.BETWEEN_12000_15000) {
        setPriceTypes([
          {
            value: "3",
            title: CONST_PRICE.BETWEEN_12000_15000,
            name: CONST_PRICE.PRICE_3,
            checked: false,
          },
        ]);
      } else if (priceChange === CONST_PRICE.FROM_15000) {
        setPriceTypes([
          {
            value: "4",
            title: CONST_PRICE.FROM_15000_TITLE,
            name: CONST_PRICE.PRICE_4,
            checked: false,
          },
        ]);
      } else {
        setPriceTypes([
          {
            value: "1",
            title: CONST_PRICE.LESS_THAN_8000_TITLE,
            name: CONST_PRICE.PRICE_1,
            checked: false,
          },
          {
            value: "2",
            title: CONST_PRICE.BETWEEN_8000_12000,
            name: CONST_PRICE.PRICE_2,
            checked: false,
          },
          {
            value: "3",
            title: CONST_PRICE.BETWEEN_12000_15000,
            name: CONST_PRICE.PRICE_3,
            checked: false,
          },
          {
            value: "4",
            title: CONST_PRICE.FROM_15000_TITLE,
            name: CONST_PRICE.PRICE_4,
            checked: false,
          },
        ]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [priceChange]);

  const filter = useMemo(() => {
    return {
      productType: "loai-2-dan-roi",
      priceRange: priceTypes,
      airConditionType: airConditionType,
      saveElectricityType: electricTypes,
      featureType: featureTypes,
      acreageWattageType: areaTypes,
      roomSplit: roomTypes,
    };
  }, [
    airConditionType,
    areaTypes,
    electricTypes,
    featureTypes,
    priceTypes,
    roomTypes,
  ]);

  let productFilter: FilterProps = {
    slug: "",
    pageSize: 12,
    pageNum: 1,
  };

  const getCongSuatLamLanhTitle = (value: string) => {
    switch (value) {
      case "1":
        return "2HP-3HP";
      case "2":
        return "3HP-4HP";
      case "3":
        return "4HP-5HP";
      case "4":
        return "5HP-6HP";
      default:
        return "2HP-3HP";
    }
  };

  const onFilter = () => {
    let selectedFilter = Object.entries(filter).reduce(
      (a, [k, v]) => (v.length === 0 ? a : ((a[k] = v), a)),
      {},
    );
    if (Object.values(selectedFilter).length > 0) {
      Object.keys(selectedFilter).forEach(k => {
        switch (k) {
          case "productType":
            productFilter = {
              ...productFilter,
              slug: filter[k],
            };
            break;
          case "airConditionType":
            productFilter = {
              ...productFilter,
              LOAI_MAY: {
                value: filter[k].map(v => v.value).join(","),
                selected: filter[k].map(v => ({
                  title: v.label,
                  name: `LOAI_MAY_${v.value}`,
                  value: v.value,
                  checked: true,
                })),
              },
            };
            break;
          case "saveElectricityType":
            productFilter = {
              ...productFilter,
              CONG_NGHE_INVERTER: {
                value: filter[k].map(v => v.value).join(","),
                selected: filter[k].map(v => ({
                  title: v.label,
                  name: `CONG_NGHE_INVERTER_${v.value}`,
                  value: v.value,
                  checked: true,
                })),
              },
            };
            break;

          case "featureType":
            filter[k].forEach(({ name, label }) => {
              productFilter = {
                ...productFilter,
                [name]: {
                  title: label,
                  checked: true,
                },
              };
            });
            break;
          case "acreageWattageType":
            productFilter =
              selectedFilter.productType === "loai-2-dan-roi"
                ? {
                  ...productFilter,
                  CONG_SUAT_LAM_LANH: {
                    value: filter[k].map(v => v.value).join(","),
                    selected: filter[k].map(v => ({
                      title: `${v.value}HP`,
                      name: `CONG_SUAT_LAM_LANH_${v.value}`,
                      value: v.value,
                      checked: true,
                    })),
                  },
                }
                : {
                  ...productFilter,
                  CONG_SUAT_LANH_SA: {
                    value: filter[k].map(v => v.value).join(","),
                    selected: filter[k].map(v => ({
                      title: getCongSuatLamLanhTitle(v.value),
                      name: `CONG_SUAT_LANH_SA_${v.value}`,
                      value: v.value,
                      checked: true,
                    })),
                  },
                };
            break;
          // TODO: filter room type
          case "roomSplit":
            let values = [];
            if (filter[k].length > 0) {
              values = [
                ...new Set(
                  filter[k].map(({ value, label }) => ({
                    title: label,
                    name: label,
                    value,
                    checked: false,
                  })),
                ),
              ];
            }
            productFilter = {
              ...productFilter,
              ROOM: {
                value: getRoomValue(values as CheckboxField[]),
                selected: filter[k].map(v => ({
                  title: v.label,
                  name: `ROOM_${v.value}`,
                  value: v.value,
                  checked: true,
                })),
              },
            };
            break;
          case "priceRange":
            productFilter = {
              ...productFilter,
              PRICE: {
                value: filter[k].map(v => v.value).join(","),
                selected: filter[k].map(v => ({
                  title: v.title,
                  name: `PRICE_${v.value}`,
                  value: v.value,
                  checked: true,
                })),
              },
            };
            break;
          default:
            break;
        }
      });
      dispatch(requestFetchProductsByType(productFilter, productFilter));
    } else {
      // toggleModal();
    }
  };

  useEffect(() => {
    if (Object.values(homeFilter).length > 0) {
      history.push(`/danh-muc/${homeFilter.slug}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [homeFilter]);

  return (
    <div className="o-filterproducts">
      <div className="o-filterproducts_heading">
        <Heading modifiers={["center", "uppercase"]}>
          LỰA CHỌN MÁY LẠNH PHÙ HỢP
        </Heading>
        <div className="o-filterproducts_close">
          <Icon iconName="close" onClick={props.onCloseAnimation} />
        </div>
      </div>
      <div className="o-filterproducts_groupcheckbox">
        <Checkbox
          name="CONG_SUAT_LAM_LANH_1"
          type="checkbox"
          value="1"
          onChange={() => onCheckValuesFilter("1", "Phòng < 12m²", "area")}
          display={`
              <span>
                1HP
                <span>
                  <br />
                  Phòng
                  &lt;12m<sup>2</sup>
                </span>
              </span>
            `}
          title="1HP"
        />
        <Checkbox
          name="CONG_SUAT_LAM_LANH_1.5"
          type="checkbox"
          value="1.5"
          onChange={() => onCheckValuesFilter("1.5", "13m² - 18m²", "area")}
          display={`
              <span>
                1.5HP
                <span>
                  <br />
                  Phòng
                  13m² - 18m²
                </span>
              </span>
            `}
          title="1.5HP"
        />
        <Checkbox
          name="CONG_SUAT_LAM_LANH_2"
          type="checkbox"
          onChange={() => onCheckValuesFilter("2", "19m² - 27m²", "area")}
          value="2"
          display={`
              <span>
                2HP
                <span>
                  <br />
                  Phòng
                  19m² - 27m²
                </span>
              </span>
            `}
          title="2HP"
        />
        <Checkbox
          name="CONG_SUAT_LAM_LANH_2.5"
          type="checkbox"
          value="2.5"
          onChange={() => onCheckValuesFilter("2.5", "28m² - 33m²", "area")}
          display={`
              <span>
                2.5HP
                <span>
                  <br />
                  Phòng
                  28m² - 33m²
                </span>
              </span>
            `}
          title="2.5HP"
        />
        <Checkbox
          name="CONG_SUAT_LAM_LANH_3"
          type="checkbox"
          value="3"
          onChange={() => onCheckValuesFilter("3", "34m² - 40m²", "area")}
          display={`
              <span>
                3HP
                <span>
                  <br />
                  Phòng
                  34m² - 40m²
                </span>
              </span>
            `}
          title="3HP"
        />
      </div>
      <div className="o-filterproducts_wrapoption">
        <GridRow>
          <GridCol colMd={12} colLg={6}>
            <Box
              iconName="money-circle"
              title="Giá Tiền"
              description={priceChange}
            >
              <RangeNumber
                min={8000000}
                max={16000000}
                step={4000000}
                defaultValue={[8000000, 12000000]}
                onChangeValue={value => setPrice(value)}
              />
            </Box>
          </GridCol>
          <GridCol colMd={12} colLg={6}>
            <Box iconName="energy-circle" title="Tiết Kiệm Điện">
              <GridRow no_gutters>
                <GridCol colSm={6} colMd={6} no_gutters>
                  <CheckboxButton
                    label=""
                    iconNoneActive={invterter}
                    iconActive={invterterActive}
                    iconXLarge
                    onChange={() =>
                      onCheckValuesFilter("1", "Có Inverter", "electric")
                    }
                  />
                </GridCol>
                <GridCol colSm={6} colMd={6} no_gutters>
                  <CheckboxButton
                    label="Không Inverter"
                    onChange={() =>
                      onCheckValuesFilter("0", "Không Inverter", "electric")
                    }
                  />
                </GridCol>
              </GridRow>
            </Box>
          </GridCol>
          <GridCol colMd={12} colLg={6}>
            <Box iconName="wind-circle" title="Loại Máy Lạnh">
              <GridRow no_gutters>
                <GridCol colSm={6} colMd={6} no_gutters>
                  <CheckboxButton
                    label="1 chiều lạnh"
                    iconNoneActive={snowflakeGray}
                    iconActive={snowflakeBlue}
                    onChange={() =>
                      onCheckValuesFilter("CO", "1 chiều lạnh", "condition")
                    }
                  />
                </GridCol>
                <GridCol colSm={6} colMd={6} no_gutters>
                  <CheckboxButton
                    label="2 chiều lạnh sưởi"
                    iconNoneActive={snowpartGray}
                    iconActive={snowpartBlue}
                    onChange={() =>
                      onCheckValuesFilter(
                        "HP",
                        "2 chiều lạnh - sưởi",
                        "condition",
                      )
                    }
                  />
                </GridCol>
              </GridRow>
            </Box>
          </GridCol>
          <GridCol colMd={12} colLg={6}>
            <Box iconName="home-circle" title="Loại Phòng" special>
              <GridRow no_gutters>
                {roomSplit.map(item => (
                  <GridCol key={item.value} colSm={6} colMd={3} no_gutters>
                    <CheckboxButton
                      label={item.label}
                      onChange={() =>
                        onCheckValuesFilter(item.value, item.label, "room")
                      }
                    />
                  </GridCol>
                ))}
              </GridRow>
            </Box>
          </GridCol>
          <GridCol colMd={12}>
            <Box iconName="setting-circle" title="Tính Năng">
              <div className="o-filterproducts_slideoption">
                {featureTypeList && (
                  <Carousel breakpoints={HOME(5)} className="small-nav-btns">
                    {featureTypeList.map(item => (
                      <SwiperSlide key={item.value}>
                        <CarouselItem>
                          <CheckboxButton
                            label={item.label}
                            iconNoneActive={item.iconNoneActive}
                            iconActive={item.iconActive}
                            iconLarge
                            onChange={() =>
                              onCheckValuesFilter(
                                item.value,
                                item.label,
                                "feature",
                                item.name,
                              )
                            }
                          />
                        </CarouselItem>
                      </SwiperSlide>
                    ))}
                  </Carousel>
                )}
              </div>
              <div className="o-filterproducts_optionfeature">
                {featureTypeList.map(item => (
                  <CheckboxButtonStyled
                    key={item.value}
                    label={item.label}
                    iconNoneActive={item.iconNoneActive}
                    iconActive={item.iconActive}
                    iconLarge
                    onChange={() =>
                      onCheckValuesFilter(
                        item.value,
                        item.label,
                        "feature",
                        item.name,
                      )
                    }
                  />
                ))}
              </div>
            </Box>
          </GridCol>
        </GridRow>
        <div className="o-filterproducts_wrapbutton">
          <Button modifiers={["rounded"]} type="button" onClick={onFilter}>
            Kết quả
          </Button>
        </div>
      </div>
    </div>
  );
};

FilterProducts.defaultProps = {};

const CheckboxButtonStyled = styled(CheckboxButton)`
  ${maxQuery(
  SizeMax.Small,
  css`
      padding-left: 0;
    `,
)}
`;

export default FilterProducts;
